import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as PushReadRateAPI from "@/api/analysis/push-read-rate";
import { isSuccess } from "@/api/response";
import { PushReadRateGetRequest } from "@/api/analysis/push-read-rate/request";
import { PushReadRateGetResponse } from "@/api/analysis/push-read-rate/response";

const MODULE_NAME = "analysis/push-read-rate/get";

/**
 *  プッシュ通知開封率取得API（/analysis-push-read-rate）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getRequest: PushReadRateGetRequest = {} as PushReadRateGetRequest;
  getResponse: PushReadRateGetResponse = {} as PushReadRateGetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getItems() {
    if (this.getResponse.results) {
      return this.getResponse.results.items || [];
    } else {
      return [];
    }
  }

  get getTotalCount() {
    if (this.getResponse.results) {
      return this.getResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getGetResponse() {
    return this.getResponse;
  }

  get getGetRequest() {
    return this.getRequest;
  }

  // MutationActions
  @MutationAction
  async get(getRequest: PushReadRateGetRequest) {
    const getResponse = await PushReadRateAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as PushReadRateGetResponse
    };
  }

  @MutationAction
  async addDateProperty(getResponse: PushReadRateGetResponse) {
    if (getResponse.results && getResponse.results["items"]) {
      getResponse.results.items.forEach(i => {
        i.date = i.sendDate;
      });
    }
    return {
      getResponse
    };
  }
}

export default getModule(Get);
